import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import { Row, Col } from 'seduo-ui';
import TileExample from '../examples/Tile';
import VideoTileDefaultExample from '../examples/VideoTileDefault';
import VideoTileEducationProgramExample from '../examples/VideoTileEducationProgram';
import TileWebinarExample from '../examples/TileWebinar';
import VideoTileCentralVolume from '../examples/VideoTileCentralVolume';
const TileExampleSource = require('!!raw-loader!../examples/Tile');
const VideoTileDefaultExampleSource = require('!!raw-loader!../examples/VideoTileDefault');
const VideoTileEducationProgramExampleSource = require('!!raw-loader!../examples/VideoTileEducationProgram');
const TileWebinarExampleSource = require('!!raw-loader!../examples/TileWebinar');
const VideoTileCentralVolumeExampleSource = require('!!raw-loader!../examples/VideoTileCentralVolume');
const TilePage = () => (<div>
        <Helmet title="Tile"/>
        <h3>Tile</h3>
        <div className="docs-example">
            <TileExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{TileExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
    title: string;
    imageSrc: string;
    large: boolean;
    href?: string;
    video?: {
        src?: string;
        type?: string;
        muted?: boolean;
        autoplay?: boolean;
        loop?: boolean;
        pause?: boolean;
    };
    overlay?: {
        topLeft?: React.ReactElement;
        topRight?: React.ReactElement;
        bottomLeft?: React.ReactElement;
        bottomRight?: React.ReactElement;
    };
    studyPlan?: {
        handleAddToStudyPlan: () => void;
        handleRemoveFromStudyPlan: () => void;
        active: boolean;
        className?: string;
        title: string;
        large?: boolean;
    };
    isMobile?: boolean;
    className?: string;
`}
                </PrismCode>
            </pre>
        </div>

        <Helmet title="Various Tiles with Badges"/>
        <h3>Various Tiles with Badges</h3>
        <p>
            Use if you want to display multiple tiles without video, only one tile with video or if you want each tile
            to have an independent muted control
        </p>
        <div className="docs-example">
            <Row>
                <Col md={6}>
                    <VideoTileDefaultExample />
                </Col>
                <Col md={6}>
                    <VideoTileEducationProgramExample />
                </Col>
                <Col md={6}>
                    <TileWebinarExample />
                </Col>
            </Row>
        </div>
        <pre>
            <PrismCode className="language-jsx">{VideoTileDefaultExampleSource}</PrismCode>
        </pre>
        <pre>
            <PrismCode className="language-jsx">{VideoTileEducationProgramExampleSource}</PrismCode>
        </pre>
        <pre>
            <PrismCode className="language-jsx">{TileWebinarExampleSource}</PrismCode>
        </pre>

        <Helmet title="VideoTile with Central Volume"/>
        <h3>VideoTile with Central Volume</h3>
        <p>Use if you want the sound to be turned on for all tiles in the collection.</p>
        <div className="docs-example">
            <VideoTileCentralVolume />
        </div>
        <pre>
            <PrismCode className="language-jsx">{VideoTileCentralVolumeExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
// include all Tile properties and
onChangeMute?: (mutedState: boolean) => void;
`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default TilePage;
